'use strict';

import * as clientconfig from "kernel/clientconfig/ClientConfig";
import SubsystemManager from "kernel/subsystem/SubsystemManager";
import Logger from "kernel/logger/Logger";
import * as Bus from "kernel/messagebus/MessageBus"; //Load full API
import queue from "kernel/bootstrap/FunctionQueue";
import currency from "kernel/currency/Currency";
import statecontroller from "kernel/statecontroller/StateController";

/**
 * @module bootstrap/Bootstrap
 * @memberof kernel
 * @description Skateboard Platform boot loader
 * @example
 * import boot from "kernel/Bootstrap",
 * boot().init(document.body);
 */
//define(function(require) {

	var subsystemManager;
	var bus;

	var config,domElement,clientservice,consoleservice,gameservice,wrappedBus,container, gameContainer,widgetContainer;

	/**
	 * @function init
	 * @param root {DOMELEMENT} root dom element
	 * @instance
	 * @description  Initialises Bootstrap Module
	 * @returns void
	 */
	function init(root) {

		domElement = root;

		// to fix SKATE-1123. Init container here as consoleservice/clientservice init before createDOM
		container = document.createElement('div');
		gameContainer = document.createElement('div');
		widgetContainer = document.createElement('div');

		var loaderQueue = queue(
			loadConfig,
			loadBus,
			initLogger,
			initSubsystem,
			createDOM, //Moved before loadConsole/client because their load progress triggers needing the first config which is only in create
			loadConsoleService,
			loadClientService,
			loadGameService,
			loadSubsystems,
			initStateController,
			loadComplete
		);

		loaderQueue.execute();
	}

	/**
	 * @function createDOM
	 * @instance
	 * @description  Defers subsystem DOM element creation to SubsystemManager
	 * @param next {function} callback function when loaded
	 * @returns void
	 */
	function createDOM(next){
		config.body = domElement;
		config.container = container;
		config.gameContainer = gameContainer;
		config.widgetContainer = widgetContainer;
		subsystemManager.create(config,function(){
			next();
		});
	}

	/**
	 * @function loadConfig
	 * @description Defers Client Configuration loading to ClientConfig module
	 * @instance
	 * @param next {function} callback function when loaded
	 * @returns void
	 */
	function loadConfig(next){
		clientconfig.load(function(data){
			config = data;
			next();
		});
	}

	/**
	 * @function loadBus
	 * @description Manages the proxying of Bus instance to other services.
	 * @instance
	 * @param next {function} callback function when loaded
	 * @returns void
	 */
	function loadBus(next){
		// Instantiate bus
		bus = Bus;//();

		var allowedDomains = [];
        function addAllowedDomain(domain) {
            if (domain) {
                allowedDomains.push(domain);
            }
        }

        addAllowedDomain(window.location.origin);
        addAllowedDomain(config.serverConfig.gameUrl);
        addAllowedDomain(config.serverConfig.server);
        addAllowedDomain(config.kernelConfig.splashUrl);

        ['TCustomView', 'BCustomView', 'LCustomView','RCustomView'].forEach(function(item){
			if (config.consoleConfig[item]) {
                addAllowedDomain(config.consoleConfig[item].consoleUrl);
			}
		});
		// Pass the postal.js config into module
		bus.init({
                allowedDomains:allowedDomains,
                defaultOrigin:window.location.origin,
                channels:[
                        { channel: 'Kernel', topic: '#', direction: 'both' },
			            { channel: 'ClientService', topic: '#', direction: 'both' },
			            { channel: 'ConsoleService', topic: '#', direction: 'both' },
			            { channel: 'Game', topic: '#', direction: 'both' },
                        { channel: 'postal.request-response', topic: '#', direction: 'both' },
						{ channel: 'GameService', topic: '#', direction:'both'}
                ]
            });

		// Wrap the bus so we remove apis that we don't want to expose to other services

		wrappedBus = function(){
		/*	return Object.freeze({
				publish:bus.publish,
				subscribe:bus.subscribe,
				unsubscribe:bus.unsubscribe,
				request:bus.request
			});

		 */
			return bus.default;
		};

		next();
	}

	/**
	 * @function initLogger
	 * @description Platform logging is enabled and wired up to bus message channel
	 * @param next {function} callback to apply when complete
	 * @returns void
	 */
	function initLogger(next){
		var logLevel = (config && config.kernelConfig && config.kernelConfig.loglevel)?
						config.kernelConfig.loglevel : 'DEBUG';
						
		Logger.init({
		  logLevel: logLevel
		});

		next();
	}

	/**
	 * @function initSubsystems
	 * @description Manages the instantiation of SubsystemManager module.
	 * @instance
	 * @param next {function} callback function when loaded
	 * @returns void
	 */
	function initSubsystem(next){
		// early instantiation of subsystemManager to allow us to access console elements
		subsystemManager = SubsystemManager();
		subsystemManager.init(bus, {
				gsEnabled: config ? config.hasOwnProperty("gameServiceConfig") : false
			}, function(){
				next();
		});
	}

	/**
	 * @function loadSubsystems
	 * @description Triggers Subsystem sequential loading
	 * @param next {function} callback function when loaded
	 * @returns void
	 */
	function loadSubsystems(next){
		subsystemManager.load(function(consoleQueue, callback){
			consoleservice.connector.onloadConsole(consoleQueue, callback);
			subsystemManager.setCECCommand(clientservice.getCECCommand());
			consoleservice.setCECCommand(clientservice.getCECCommand()); //SKATE-5452 - This needs to be here to prevent a CEC init race.AAA
		}, function(){
			next();
		});
	}

	/**
	 * @function loadClientService
	 * @instance
	 * @param next {function} callback function when loaded
	 * @description Load the Client Service Component of Skateboard Platform
	 * @returns void
	 */
	function loadClientService(next){
		import(/* webpackChunkName: "clientservice" */ 'clientservice/main').then(({default:ClientService}) => {
			clientservice = ClientService;
			clientservice.load({
				bus:wrappedBus, 
				currency:currency,
				root: container,
				gameRoot : gameContainer,
				logger: Logger,
				consoleconnect : consoleservice.connector,
				assetPack : config.serverConfig.paramGame.assetPack,
				clientConfig : config
			},function(){
				next();
			});
		}).catch(function(err){
			console.log('ERROR: ',err);
			onError(err);
		});
	}


	/**
	 * @function loadGameService
	 * @instance
	 * @param next {function} callback function when loaded
	 */
	function loadGameService(next){		
		if(config.hasOwnProperty("gameServiceConfig")){
			import(/* webpackChunkName: "gameservice" */ 'gameservice/main').then(({default:GameService}) => {
				gameservice = GameService;
				gameservice.load({
					bus: wrappedBus,
					root: container,
					widgetRoot: widgetContainer,
					currency: currency,
					logger: Logger,
					clientConfig : config
				}, function () {
					next();
				});
			}).catch(onError);
		}else{
			next();
		}
	}

	/**
	 * @function loadConsoleService
	 * @instance
	 * @param next {function} callback function when loaded
	 * @description Load the Console Service Component of Skateboard Platform
	 */
	function loadConsoleService(next){
		import(/* webpackChunkName: "consoleservice" */'consoleservice/main').then(({default:ConsoleService}) => {
			consoleservice = ConsoleService;
			consoleservice.load({
				bus: wrappedBus,
				currency: currency,
				root: container,
				logger: Logger,
				clientConfig : config
			}, function () {
				next();
			});
		}).catch(onError);
	}

	/**
	 * @function onError
	 * @instance
	 * @description  Handle module loading errors in Kernel
	 * @param data {object} Error stack trace
	 * @returns void
	 */
	function onError(data){
		if(Logger && Logger.warn) {
			Logger.warn('com.igt.skateboard:',data);
		}
		else {
			console.warn('com.igt.skateboard:',data);
		}		
	}

	/**
	 * @function loadComplete
	 * @description When all subsystems have loaded continue the sequence
	 * @param next
	 */
	function loadComplete(next){
		consoleservice.setCECCommand(clientservice.getCECCommand());
		next();
	}

	/**
	 * @function initStateController
	 * @description Begin the State Flow
	 * @param next
	 */
	function initStateController(next){

		// only give state controller the config it needs
		var wrappedConfig = {
			serverConfig:config.serverConfig,
			gameConfig:config.gameConfig,
            kernelConfig:config.kernelConfig, //SKATE-5546 - we need kernelConfig
			widgetConfig:config.widgetConfig  //SKATE-6503 - this config was missing
		};

		statecontroller({
			bus:wrappedBus,
			clientconfig:wrappedConfig,
			consoleservice:consoleservice.connector,
			clientservice:clientservice.controller,
			gameservice: gameservice ? gameservice.controller : (void 0),
			reveal:subsystemManager.reveal,
			currency:currency,
			cecCommand:clientservice.getCECCommand()
		},function(){
			next();
		});
	}

	export default function() {

		return Object.freeze({
			init:init, // TODO - all following should not been exposed
			loadConfig:loadConfig,
			loadBus:loadBus,
			loadConsoleService:loadConsoleService,
			loadClientService:loadClientService,
			initLogger:initLogger,
			initSubsystem:initSubsystem,
			createDOM:createDOM,
			loadSubsystems:loadSubsystems
		});
	}
